// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"bM-z","carouselContainer":"cM-z"};